var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgButtonCreate(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8982 5.88611H9.89819V9.88611H5.89819V11.8861H9.89819V15.8861H11.8982V11.8861H15.8982V9.88611H11.8982V5.88611ZM10.8982 0.886108C5.37819 0.886108 0.898193 5.36611 0.898193 10.8861C0.898193 16.4061 5.37819 20.8861 10.8982 20.8861C16.4182 20.8861 20.8982 16.4061 20.8982 10.8861C20.8982 5.36611 16.4182 0.886108 10.8982 0.886108ZM10.8982 18.8861C6.48819 18.8861 2.89819 15.2961 2.89819 10.8861C2.89819 6.47611 6.48819 2.88611 10.8982 2.88611C15.3082 2.88611 18.8982 6.47611 18.8982 10.8861C18.8982 15.2961 15.3082 18.8861 10.8982 18.8861Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonCreate);
export default __webpack_public_path__ + "static/media/buttonCreate.9c01c92f38dd830d2d3c77ea1898f55f.svg";
export { ForwardRef as ReactComponent };